import { isEmpty, isUndefined, result } from 'lodash';
import numeral from 'numeral';
import React, { useState } from 'react';
import Autosuggest from 'react-autosuggest';
import styles from './NewFundSearch.scss';

import config from '../../../../config/config';
import { getFundLimit } from '../../../../utils/transactions-util';
import NewFundSearchSuggestionNotes from './NewFundSearchSuggestionNotes';
import NewFundSearchSelectedFundNotes from './NewFundSearchSelectedFundNotes';
import {
  closeModal,
  REINVEST_TO_NEW_CORE,
} from '../../../../redux/modules/modals/modals.module';
import Button from '../../../../components/Button/Button';
import Loader from '../../../../components/Loader/Loader';
import { agreementTypeToDisplay } from '../../../../utils/fund-utils';
import {
  coalesce,
  getHouseHoldInformation,
  hasValue,
} from '../../../../utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectFund,
  updateSelectedReinvestment,
} from '../../../../redux/modules/shoppingCart/shoppingCart.module';
import { getUserExistingTickers } from '../../../../redux/modules/UserFunds/userFunds.selectors';
import { getHouseholdBalanceTierStatus } from '../../../../redux/modules/PersonalInformation/personalInformation.selectors';
import { v4 as uuidv4 } from 'uuid';

const registrationTypeURLMap = {
  Maryland529:
    'https://maryland529.com/college-savings-plans-of-maryland/maryland-college-investment-plan/investment-options',
  Alaska529: 'https://www.alaska529plan.com/investment-options.html',
  National529:
    'https://www.troweprice.com/personal-investing/troweprice-529/investment-options.html',
  MutualFund: `${config.url}/personal-investing/tools/fund-research/`,
  defaultURL: `${config.url}/personal-investing/tools/fund-research/`,
};

export const NewFundSearch = ({ exchangeToNewLoading, availableFundList }) => {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     started: true,
  //     focused: false,
  //     value: '',
  //     suggestions: [],
  //     ticker: '',
  //     selectedFund: {},
  //     addNewFundDisable: true,
  //     newAgreementId: uuidv4(), // generating uniqueId for the new added fund as agreementId
  //   };
  //addFundButton = React.createRef();
  //   this.onFocus = this.onFocus.bind(this);
  //   this.onBlur = this.onBlur.bind(this);
  // }

  // componentDidMount() {
  //   const {
  //     actions: { getTRPFunds },
  //     addFunds,
  //     dispatchPageLoad,
  //   } = this.props;
  //   if (isEmpty(addFunds)) {
  //     getTRPFunds();
  //   }
  //   dispatch('New Fund Search');
  // }

  // componentWillUnmount() {
  //   const { newAgreementId } = this.state;
  //   setTimeout(
  //     () => scrollElementIntoFullView(`fund-agreement-${newAgreementId}`),
  //     150
  //   );
  // }

  const [ticker, setTicker] = useState([]);
  const [value, setValue] = useState('');
  const addFunds = availableFundList;
  const userRegistrationTypeInfo = {
    selectedRegistrationType: {
      agreementType: '',
      formattedEntityNames: undefined,
      productType: 'MUTUAL_FUND',
      uniqueKey: uuidv4(),
    },
  };
  //availableFundList already has Iclass and restricted funds blocked
  const dispatch = useDispatch();
  const { selectedRegistrationType } = userRegistrationTypeInfo;
  const householdBalanceTierStatus = useSelector(getHouseholdBalanceTierStatus);
  const [selectedFund, setSelectedFund] = useState({});
  const [focused, setFocused] = useState(false);
  const [suggestions, setSuggestions] = useState(availableFundList);
  const [fundProgress, setFundProgress] = useState('');
  // TODO: Replace with <EmphasizeSubtext /> but need to extract applyTrpRephraseRules from EmphasizeSubtext first
  function getSuggestion(suggestion, q) {
    const suggestionText = `${suggestion}`;
    const i = suggestionText?.toLowerCase().indexOf(q?.toLowerCase());
    if (i === -1) {
      return suggestion;
    }
    const pre = suggestionText.slice(0, i) || null;
    const queryText = suggestionText.slice(i, i + q?.length);
    const post =
      suggestionText.slice(i + q?.length, suggestion?.length) || null;
    return (
      <span>
        {pre && <span>{pre}</span>}
        <span className="new-fund-search-suggestion-match">{queryText}</span>
        {post && <span>{post}</span>}
      </span>
    );
  }

  /**
   * @param {AllFund} fund
   * @param {string} query
   * @returns {object}
   */
  function renderSuggestion(fund, { query }) {
    const showSymbol = true;
    /* Checking this to show new Modal design */
    const isMFBuyOrExchange = true;
    return (
      <div
        className={
          fund.disabled
            ? 'new-fund-search-fund-disable'
            : 'new-fund-search-fund-enable'
        }
      >
        {isMFBuyOrExchange ? (
          <div className="new-fund-search-suggestion-name-scs">
            {getSuggestion(fund.name, query)}
            {showSymbol && (
              <span className="new-fund-search-suggestion-ticker-scs">
                ({getSuggestion(fund.ticker, query)})
              </span>
            )}
          </div>
        ) : (
          <>
            {showSymbol && (
              <div className="new-fund-search-suggestion-ticker">
                {getSuggestion(fund.ticker, query)}
              </div>
            )}
            <div>{getSuggestion(fund.name, query)}</div>{' '}
          </>
        )}
        <NewFundSearchSuggestionNotes
          fund={fund}
          fundType={fundType}
          scsTier={getHouseHoldTier()}
        />
      </div>
    );
  }

  function shouldRenderSuggestions() {
    return focused;
  }

  function getSuggestions(value) {
    const addFunds = availableFundList;
    if (addFunds?.length === 0) {
      return [];
    }
    const inputValue = coalesce(value, '').trim().toLowerCase();
    const inputLength = inputValue?.length;
    const regex = new RegExp('\\b' + value, 'i');

    const suggestedFunds = (
      inputLength === 0
        ? availableFundList
        : availableFundList.filter(
          (fund) => regex.test(fund.name) || regex.test(fund.ticker)
        )
    ).filter((fund) => {
      /* Dont show core clients closed funds */
      if (!isSCSTier && !fund.openToNewInvestors) {
        return false;
      }
      return true;
    });
    return suggestedFunds;
  }

  function getSuggestionValue(suggestion) {
    if (suggestion?.disabled) {
      setValue(''), setSelectedFund({}), setTicker([]);
    } else {
      setTicker(suggestion?.ticker), setSelectedFund(suggestion);
    }
    return suggestion?.name;
  }

  function onSuggestionSelected() {
    if (suggestions.disabled) {
      setValue(''), setSelectedFund({}), setTicker([]);
    }
  }

  function onFocus() {
    setFocused(true);
  }

  function onBlur() {
    setFocused(false);
  }

  function onChange(event, obj) {
    if (!isUndefined(obj.newValue)) {
      const newValue = obj.newValue;
      if (newValue?.length === 0) {
        setSelectedFund({});
        setTicker([]);
      }
      setValue(newValue);
    }
  }

  function onSuggestionsFetchRequested({ value }) {
    const suggestedFunds = getSuggestions(value);
    setSuggestions(suggestedFunds);
  }

  function onSuggestionsClearRequested() {
    setSuggestions([]);
  }

  function renderInputComponent(inputProps) {
    /* Checking this to show new Modal design */
    const showSymbol = true;
    const isMFBuyOrExchange = true;
    return (
      <div>
        <input
          {...inputProps}
          className={`e2e-new-fund-search-input ${coalesce(
            inputProps.className,
            ''
          )}`}
        />
        {showSymbol && (
          <div
            className={`new-fund-search-search-box-ticker ${isMFBuyOrExchange && 'new-fund-search-search-box-ticker-scs'
              }`}
          >
            {ticker}
          </div>
        )}
      </div>
    );
  }

  function onAddNewFundClick() {
    // const {
    //   userRegistrationTypeInfo: { selectedRegistrationType },
    //   actions: { addToNewFund, closeModal, selectFund },
    //   availableFundList,
    // } = this.props;
    // const { selectedFund } = state;
    // const { newAgreementId } = state;

    const newFund = {
      ...selectedFund,
      ...selectedRegistrationType,
      newFund: true,
      agreementID: uuidv4(),
      displayClassification: 'NON_RETIREMENT',
      fundName: selectedFund.name,
      selected: true,
      bankAssociated: true,
    };
    const selectedRegistrationProductType =
      selectedRegistrationType &&
        selectedRegistrationType?.productType === 'MUTUAL_FUND'
        ? 'MutualFund'
        : selectedRegistrationType.productType;

    const nextFund = availableFundList.filter(
      (fund) =>
        fund.displayClassification === newFund.displayClassification &&
        fund.agreementType === newFund.agreementType
    );

    const newlyAddedFund = newFund;
    // const newlyAddedFund = availableFundList.filter(
    //   (fund) => fund.formattedEntityNames === newFund.formattedEntityNames
    // ); // This is the problem maybe
    newFund.productType = selectedRegistrationProductType || 'MutualFund';
    const newAgreementId = uuidv4();
    // added Undefined check because the BPID for non minorIRA returns '0'.
    // if the value is 0 it takes as false and returns null. which will not return any IRA Limits.
    newFund.BPID =
      newlyAddedFund && !isUndefined(newlyAddedFund['BPID'])
        ? newlyAddedFund['BPID']
        : null;
    newFund.ownerName = newlyAddedFund && newlyAddedFund.ownerName;
    newFund.isMinorIRA = newlyAddedFund && newlyAddedFund.isMinorIRA;
    newFund.sortRank = nextFund ? nextFund.sortRank - 1 : Number.MAX_VALUE;
    dispatch(updateSelectedReinvestment(newFund)); // Note: In case of exchange this is actually addExchangeToNewFund
    selectFund(newAgreementId, newFund, newFund.BPID); // Note: In case of exchange this is actually selectExchangeToFund
    dispatch(closeModal(REINVEST_TO_NEW_CORE));
  }

  function shouldButtonDisable() {
    return ticker?.length === 0;
  }

  function getButtonStyle() {
    return shouldButtonDisable()
      ? 'btn btn-trp-primary btn-disabled'
      : 'btn btn-trp-primary';
  }

  function onBackClick() {
    setFundProgress('REGISTRATION');
  }

  function onEnterKeyDown(e) {
    if (e.keyCode !== 13 || ticker === '') {
      return;
    }

    const fundName = 'name';
    //   find(addFunds, (obj) => {
    //     return obj.ticker === ticker;
    //   }),
    //   'name'
    // );
    if (e.target.value !== fundName) {
      setValue(''), setSelectedFund({}), setTicker([]);
    }
    // Need to delay the focus call or else the enter press will get passed to the button
    // and it'll trigger a click; funky.
    //setTimeout(() => addFundButton.current.focus(), 10);
  }

  const getHouseHoldTier = () => {
    return getHouseHoldInformation(householdBalanceTierStatus);
  };

  const {
    agreementType = '',
    formattedEntityNames = '',
    productType = 'MUTUAL_FUND', // Renaming `productType` to give it more meaning when used
  } = selectedRegistrationType;

  const closedFunds = addFunds?.filter(
    (fund) =>
      !fund.openToNewInvestors &&
      !fund.iClass &&
      !(!fund.openToNewInvestors && !fund.openToSubsequentInvestments)
  );

  //temp will go back for these
  const fundType = 'Individual';
  const showIClass = false;
  const showProspectus = false;
  const showSymbol = true;
  const isMutualFundBuyOrExchange = true;
  const isSCSTier = getHouseHoldTier();
  const currentFunds = isSCSTier ? closedFunds : '';
  const loaderStyle = {
    height: '600px',
    paddingTop: '200px',
    textAlign: 'center',
  };
  const registrationName = agreementTypeToDisplay(agreementType);
  // TODO generic this loading indicator for all flows
  if (exchangeToNewLoading) {
    return (
      <Loader contextStyle={loaderStyle} color="rgb(118, 118, 118)" isVisible />
    );
  }

  const autoSuggestInput = (
    <Autosuggest
      alwaysRenderSuggestions={focused}
      suggestions={suggestions}
      focusInputOnSuggestionClick={false}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      inputProps={{
        'aria-label': `Lookup new ${fundType} by name ${showSymbol ? 'or symbol' : ''
          }`,
        placeholder: `Enter ${fundType} name ${showSymbol ? 'or symbol' : ''}`,
        value,
        onChange: onChange,
        size: '70',
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onEnterKeyDown,
      }}
      shouldRenderSuggestions={shouldRenderSuggestions}
      //theme={}
      renderInputComponent={renderInputComponent}
      onSuggestionSelected={onSuggestionSelected}
    />
  );

  return (
    <div>
      <div className="new-fund-search scs-newfund-search">
        <div className="new-fund-search-registration-type-line">
          <span className="e2e-new-fund-user-names-scs blocked_data">
            Search Funds
          </span>
        </div>
        <div className="new-fund-search-autosuggestion-container e2e-new-fund-search-input-container scs-main-container">
          {autoSuggestInput}
          <div>
            {isSCSTier && (
              <div>
                <div className="closed-fund-title">
                  You have access to invest in closed funds:
                </div>
                <div className="closed-funds-subheader">
                  I Class funds can be opened by going through the new account
                  set-up process and cannot be opened through an Auto-RMD
                  submission.
                </div>
              </div>
            )}
            {isSCSTier && (
              <div className="grid-wrapper">
                {currentFunds &&
                  currentFunds.map((fund) => (
                    <>
                      {!fund.disabled && (
                        <div className="box new-fund-button-container">
                          <div className="header">
                            {fund.name} - {fund.ticker}
                          </div>
                          <Button
                            id={`new-fund-box-${fund.ticker}`}
                            disabled={false}
                            className="new-fund-button"
                            onClick={() => {
                              setValue(getSuggestionValue(fund));
                            }}
                          >
                            Add Fund
                          </Button>
                        </div>
                      )}
                    </>
                  ))}
              </div>
            )}
          </div>
          <div className="space"></div>

          <div className="new-fund-mutual-fund-message">
            Visit our{' '}
            <a
              className="research-tool"
              target="_blank"
              href="https://www.troweprice.com/personal-investing/tools/fund-research/"
              rel="noreferrer"
            >
              Mutual Fund Research Tool
            </a>{' '}
            to learn more and find the right fund for your investment strategy.
          </div>
          {isSCSTier && (
            <div
              className={`new-fund-search-buttons-container-scs ${hasValue(selectedFund) ? 'selected' : ''
                }`}
            >
              {hasValue(selectedFund) ? (
                <div className="selected-fund-container">
                  <div className="new-fund-search-chosen-fund">
                    SELECTED FUND
                  </div>
                  <span className="added-fund">
                    {selectedFund.name} ({selectedFund.ticker})
                  </span>
                  <div className="new-fund-search-chosen-agreement">
                    I have read the prospectus for the fund in which I am
                    investing and agree to its terms.{' '}
                    <a
                      target="_blank"
                      href={`https://prospectus-express.broadridge.com/summary.asp?doctype=spro&clientid=trowepll&fundid=${selectedFund.cusip}`}
                      rel="noreferrer"
                    >
                      View Prospectus.
                    </a>
                  </div>
                  <NewFundSearchSelectedFundNotes
                    selectedFund={selectedFund}
                    showProspectus={showProspectus}
                    // selectedRegistrationProductType={
                    //   selectedRegistrationProductType
                    // }
                    scsProgram={true}
                  />
                </div>
              ) : (
                <div />
              )}
              <Button
                id="fund-search-back-submit"
                btnStyle={getButtonStyle()}
                className="open-account-button"
                disabled={shouldButtonDisable()}
                onClick={() => {
                  onAddNewFundClick();
                }}
              //ref={addFundButton()}
              >
                Add Fund
              </Button>
            </div>
          )}
        </div>
        {!isSCSTier && (
          <div
            className={`new-fund-search-buttons-container-scs ${hasValue(selectedFund) ? 'selected' : ''
              }`}
          >
            {hasValue(selectedFund) ? (
              <div className="selected-fund-container">
                <div className="new-fund-search-chosen-fund">SELECTED FUND</div>
                <span className="added-fund">
                  {selectedFund.name} ({selectedFund.ticker})
                </span>
                <div className="new-fund-search-chosen-agreement">
                  I have read the prospectus for the fund in which I am
                  investing and agree to its terms.{' '}
                  <a
                    target="_blank"
                    href={`https://prospectus-express.broadridge.com/summary.asp?doctype=spro&clientid=trowepll&fundid=${selectedFund.cusip}`}
                    rel="noreferrer"
                  >
                    View Prospectus.
                  </a>
                </div>
                <NewFundSearchSelectedFundNotes
                  selectedFund={selectedFund}
                  showProspectus={showProspectus}
                  // selectedRegistrationProductType={
                  //   selectedRegistrationProductType
                  // }
                  scsProgram={true}
                />
              </div>
            ) : (
              <div />
            )}
            <Button
              id="fund-search-back-submit"
              btnStyle={getButtonStyle()}
              className="open-account-button"
              disabled={shouldButtonDisable()}
              onClick={() => {
                onAddNewFundClick();
              }}
            //ref={addFundButton()}
            >
              Add Fund
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
export default NewFundSearch;
